/**
 * @file
 * A JavaScript file containing the main menu functionality (small/large screen)
 *
 */

(function (Drupal) {

  Drupal.behaviors.mobileMenuButton = {
    attach: function (context) {
      'use strict';

      function whichTransitionEvent(){
        var t,
            el = document.createElement("fakeelement");

        var transitions = {
          "transition"      : "transitionend",
          "OTransition"     : "oTransitionEnd",
          "MozTransition"   : "transitionend",
          "WebkitTransition": "webkitTransitionEnd"
        }

        for (t in transitions){
          if (el.style[t] !== undefined){
            return transitions[t];
          }
        }
      }

      var mobileMenuButtons = context.getElementsByClassName('mobile-menu-button');
      var mobileMenu = context.querySelector('.site-mobile-menu');
      var bodyElement = context.querySelector('body');

      if(mobileMenuButtons.length > 0 && mobileMenu) {
        var transitionEvent = whichTransitionEvent();

        // Mobile Menu Show/Hide.
        for (var i = 0; i < mobileMenuButtons.length; i++) {
          mobileMenuButtons[i].addEventListener('click', function (e) {

            bodyElement.classList.add('no-flow');
            this.classList.toggle('mobile-menu-button--open');
            mobileMenu.classList.toggle('site-mobile-menu--open');

            transitionEvent && mobileMenu.addEventListener(transitionEvent, function(e) {
              if(e.propertyName == "right" && !mobileMenu.classList.contains('site-mobile-menu--open')) {
                bodyElement.classList.remove('no-flow');
              }
            });
          });
        }
      }
    }
  }

})(Drupal);
